import React from 'react';
import {noop} from 'lodash';

import ActivatedOn from '/component/partial/report/ActivatedOn';
import {FrontlineClientRole} from '/component/partial/report/FrontlineClientRole';
import {PeopleRole} from '/component/partial/report/PeopleRole';
import PersonFullName from '/component/partial/report/PersonFullName';
import {NO_ORDER} from '/enum/peopleToContact.enum';
import {
  REPORT_CLIENT_TO_CONTACT,
  REPORT_CLIENT_TO_CONTACT_NO_ORDER,
} from '/enum/records.enum';
import {FILTER_TYPES} from '/enum/tealium.enum';

import {generateOnRecordPress} from '../PeopleToContact.util';
import {PeopleToContactDataProvider} from '../PeopleToContactDataProvider';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface FeatureFlag {
  CC_SR: boolean;
}

interface NoOrderProps {
  featureFlag: FeatureFlag;
  onItemPress: (item: {
    value: number;
    recordsName: string;
    filterName: string;
  }) => void;
  onShowProfile: () => void;
  parentScreenName: string;
  showFullReport: boolean;
  reportParams: any;
}

export const NoOrder: React.FC<NoOrderProps> = ({
  onItemPress = noop,
  onShowProfile = noop,
  parentScreenName = '',
  showFullReport = false,
  reportParams = null,
  featureFlag = {
    CC_SR: false,
  },
}) => {
  const {sortParam} = useRecordsSorting({
    recordsName: REPORT_CLIENT_TO_CONTACT_NO_ORDER,
  });

  const onViewMore = () => {
    onItemPress({
      value: 0,
      recordsName: REPORT_CLIENT_TO_CONTACT,
      filterName: REPORT_CLIENT_TO_CONTACT_NO_ORDER,
    });
  };

  // if the context has not been initialized yet, we take sorting from
  // the parent (default sorting)
  const defaultSorting = sortParam?.params
    ? [{...sortParam?.params}]
    : reportParams;

  return (
    <PeopleToContactDataProvider
      screenParams={{type: NO_ORDER}}
      clientMilestone={FILTER_TYPES.noOrder}
      onViewMore={onViewMore}
      reportParams={defaultSorting}
      reportName={REPORT_CLIENT_TO_CONTACT_NO_ORDER}
      parentScreenName={parentScreenName}
      dataRendererProps={{
        personNameComponent: PersonFullName,
        personRoleComponent: featureFlag.CC_SR
          ? PeopleRole
          : FrontlineClientRole,
        personInfoComponent: ActivatedOn,
        onRecordPress: generateOnRecordPress({
          onShowProfile,
        }),
        showFullReport,
      }}
    />
  );
};
